const OwalListRowAccessoryType = {
  NONE: 0,
  CHEVRON: 1,
  ARROW: 2,
  properties: {
    0: { description: 'none' },
    1: { description: 'chevron' },
    2: { description: 'arrow' },
  },
}

if (Object.freeze) {
  Object.freeze(OwalListRowAccessoryType)
}

export { OwalListRowAccessoryType }
